export const EmailIconV2 = (props) => (
  <svg fill="none" height={18} viewBox="0 0 18 18" width={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.25 6L8.1675 9.945C8.414 10.1095 8.70368 10.1972 9 10.1972C9.29632 10.1972 9.586 10.1095 9.8325 9.945L15.75 6M3.75 14.25H14.25C14.6478 14.25 15.0294 14.092 15.3107 13.8107C15.592 13.5294 15.75 13.1478 15.75 12.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V12.75C2.25 13.1478 2.40804 13.5294 2.68934 13.8107C2.97064 14.092 3.35218 14.25 3.75 14.25Z"
      stroke="#A0A5AF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
